import React from 'react'
import { FormattedMessage } from 'react-intl'

const LineSteps = ({ step, setStep }) => {

    return (
        <div className='pt-20 w-[80%] mx-auto '>
            <ol className="flex items-center cursor-pointer w-full text-sm font-medium text-center text-gray-500 dark:text-gray-400 sm:text-base">
                <li
                    onClick={() => step > 0 && setStep(0)} // Allow going back only
                    className={`flex md:w-full cursor-pointer items-center ${step >= 0 ? "text-primary dark:text-primary" : ""}  sm:after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700`}>
                    <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
                        <span className="me-2">1</span>
                        <span className='me-2'><FormattedMessage id="choose" defaultMessage={"Choose"} /></span>
                        {step > 0 && (
                            <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                        )}
                    </span>
                </li>
                <li
                    onClick={() => step > 1 && setStep(1)} // Allow going back only
                    className={`flex md:w-full cursor-pointer items-center ${step >= 1 ? "text-primary dark:text-primary" : ""}  after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700`}>
                    <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
                        <span className="me-2">2</span>
                        <span className='mr-1'><FormattedMessage id="personal" defaultMessage={"Personal"} /></span>
                        <span className="hidden sm:inline-flex sm:me-2"><FormattedMessage id="info" defaultMessage={"Info"} /></span>
                        {step > 1 && (
                            <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                        )}
                    </span>
                </li>
                <li
                    onClick={() => step > 2 && setStep(2)} // Allow going back only
                    className={`flex items-center ${step >= 2 ? "text-primary dark:text-primary" : ""} `}>
                    <span className="me-2">3</span>
                    <FormattedMessage id="confirmation" defaultMessage={"Confirmation"} />
                </li>
            </ol>
        </div>
    )
}

export default LineSteps
